import { getStorage, ref } from 'firebase/storage';

class Storage {
  constructor(app, helpers) {
    this.instance = getStorage(app);
    this.root = helpers;
  }

  getProfileImage(profileUid) {
    // return this.instance.ref().child(`profileImages/${profileUid}`);
    return ref(this.instance, `profileImages/${profileUid}`);
  }

  getPropertyImage(propertyUid, imageUid) {
    // return this.instance
    //   .ref()
    //   .child(`propertyImages/${propertyUid}/${imageUid}`);
    return ref(this.instance, `propertyImages/${propertyUid}/${imageUid}`);
  }

  getPropertyDocument(propertyUid, documentUid) {
    // return this.instance
    //   .ref()
    //   .child(`propertyDocuments/${propertyUid}/${documentUid}`);
    return ref(
      this.instance,
      `propertyDocuments/${propertyUid}/${documentUid}`
    );
  }

  getInventoryImage(propertyUid, imageUid) {
    // return this.instance
    //   .ref()
    //   .child(`inventoryImages/${propertyUid}/${imageUid}`);
    return ref(this.instance, `inventoryImages/${propertyUid}/${imageUid}`);
  }

  getAccountImage(profileUid, imageUid) {
    // return this.instance.ref().child(`accountImages/${profileUid}/${imageUid}`);
    return ref(this.instance, `accountImages/${profileUid}/${imageUid}`);
  }

  getCurrentAccountImage(imageUid) {
    return this.getAccountImage(this.root.getCurrentUserUid(), imageUid);
  }

  getMessageImage(tenancyUid, imageUid) {
    // return this.instance.ref().child(`messageImages/${tenancyUid}/${imageUid}`);
    return ref(this.instance, `messageImages/${tenancyUid}/${imageUid}`);
  }

  destroy() {
    this.instance = null;
  }
}

export default Storage;
